import React from 'react';

const STEP_PERCENTAGES = [33.33, 66.66, 99.99, 100];

const clampStep = (stepValue) => {
  const totalSteps = STEP_PERCENTAGES.length;
  const numericStep = Number(stepValue);

  if (!Number.isFinite(numericStep)) {
    return 1;
  }

  return Math.min(Math.max(Math.round(numericStep), 1), totalSteps);
};

const StepProgressBar = ({ activeStep, pendingStep }) => {
  const currentStep = clampStep(activeStep ?? pendingStep ?? 1);
  const pendingIndex = pendingStep ? clampStep(pendingStep) - 1 : -1;

  return (
    <div className="step-progress-bar border bg-primary w-100">
      <div className="step-track">
        <div className="step-fill" style={{ width: `${STEP_PERCENTAGES[currentStep - 1]}%` }} />
      </div>

      <div className="step-list d-flex justify-content-between align-items-center">
        {STEP_PERCENTAGES.map((_, index) => {
          const isAccomplished = index < currentStep;
          const isPending = index === pendingIndex;

          return (
            <div
              key={index}
              className={`step ${isAccomplished ? 'active' : ''} ${isPending ? 'pending' : ''} d-flex align-items-center justify-content-center`}
            >
              <div className="dot rounded-circle position-relative" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepProgressBar;